import React, { useState, useEffect } from "react";
import { db } from "../../config/firebase";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { Modal, Timeline } from "antd";
import { HistoryOutlined } from "@ant-design/icons";

const History = ({ prefixType }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const historyRef = collection(db, "prefixHistory");
            const querySnapshot = await getDocs(historyRef);
            let history = querySnapshot.docs
                .map((doc) => ({ id: doc.id, ...doc.data() }))
                .filter((item) => item.prefixType === prefixType) // Manual filtering
                .sort((a, b) => b.timestamp - a.timestamp); // Sorting manually

            setHistoryData(history);
        } catch (error) {
            console.error(`Error fetching ${prefixType} history:`, error);
        } finally {
            setLoading(false);
        }
    };


    const showModal = () => {
        fetchHistory();
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return "Unknown date";

        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return date.toLocaleString();
    };

    return (
        <>
            <button
                onClick={showModal}
                className="ml-2 text-gray-600 hover:text-blue-600 focus:outline-none"
                title="View History"
            >
                <HistoryOutlined style={{ fontSize: '18px' }} />
            </button>

            <Modal
                title={`${prefixType} History`}
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={600}
            >
                {loading ? (
                    <div className="flex justify-center py-4">Loading history...</div>
                ) : historyData.length === 0 ? (
                    <div className="py-4 text-center">No history available</div>
                ) : (
                    <Timeline>
                        {historyData.map((item) => (
                            <Timeline.Item key={item.id} color="blue">
                                <div className="font-medium">
                                    Changed from "{item.oldValue}" to "{item.newValue}"
                                </div>
                                <div className="text-xs text-gray-500">
                                    By {item.updatedBy} on {formatDate(item.timestamp)}
                                </div>
                            </Timeline.Item>
                        ))}
                    </Timeline>
                )}
            </Modal>
        </>
    );
};

export default History;